import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    staticClass: "warehouse-importer-add-edit-modal",
    attrs: {
      "data-sign": "product_wrapper_add_edit_modal",
      "width": 800,
      "title": _vm.rowData.title
    },
    on: {
      "cancel": _vm.handleClose
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('a-form-model', {
    ref: "formDataRef",
    attrs: {
      "layout": "vertical",
      "data-sign": "product_wrapper_add_edit_form",
      "rules": _vm.formDataRule,
      "model": _vm.formData
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5546\u54C1\u7F16\u7801"),
      "prop": "product_sku",
      "label": _vm.t('商品编码')
    }
  }, [_c('request-auto-complete', {
    attrs: {
      "searchFunction": _vm.handleSearchSkuList
    },
    on: {
      "blur": function ($event) {
        return _vm.handleCheckSelectedProductSku(_vm.formData.product_sku || '');
      },
      "select": _vm.handleSelectProductSku
    },
    model: {
      value: _vm.formData.product_sku,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "product_sku", $$v);
      },
      expression: "formData.product_sku"
    }
  }, [_c('template', {
    slot: "dataSource"
  }, _vm._l(_vm.productList, function (item) {
    return _c('a-select-option', {
      key: item.product_sku,
      attrs: {
        "value": item.product_sku
      }
    }, [_vm._v(_vm._s(item.product_sku))]);
  }), 1)], 2)], 1), _c('div', {
    staticClass: "flex-box"
  }, [_c('a-form-model-item', {
    staticClass: "flex-item mr-20",
    attrs: {
      "fbu-analyse-name": $t("\u5546\u54C1\u540D\u79F0"),
      "label": _vm.t('商品名称')
    }
  }, [_c('a-input', {
    attrs: {
      "value": _vm.detailsData.product_name_cn,
      "disabled": ""
    }
  })], 1), _c('a-form-model-item', {
    staticClass: "flex-item",
    attrs: {
      "fbu-analyse-name": $t("SKU\u5305\u88C5\u5C5E\u6027"),
      "label": _vm.t('SKU包装属性')
    }
  }, [_c('a-input', {
    attrs: {
      "value": _vm.detailsData.sku_wrapper_type_text,
      "disabled": ""
    }
  })], 1)], 1), _c('div', {
    staticClass: "flex-box"
  }, [_c('a-form-model-item', {
    staticClass: "flex-item mr-20",
    attrs: {
      "fbu-analyse-name": $t("\u5546\u54C1\u9884\u62A5\u5C3A\u5BF8\uFF08cm\uFF09"),
      "label": _vm.t('商品预报尺寸（cm）')
    }
  }, [_c('a-input', {
    attrs: {
      "value": _vm.getSizeText(_vm.detailsData),
      "disabled": ""
    }
  })], 1), _c('a-form-model-item', {
    staticClass: "flex-item",
    attrs: {
      "fbu-analyse-name": $t("\u5546\u54C1\u9884\u62A5\u91CD\u91CF\uFF08kg\uFF09"),
      "label": _vm.t('商品预报重量（kg）')
    }
  }, [_c('a-input', {
    attrs: {
      "value": _vm.detailsData.declare_weight,
      "disabled": ""
    }
  })], 1)], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u9002\u7528\u4ED3\u5E93\uFF08\u533A\u57DF\uFF09"),
      "prop": "warehouse_code",
      "label": _vm.t('适用仓库（区域）')
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('请选择适用仓库（区域）')
    },
    on: {
      "change": _vm.handleWhCodeChange
    },
    model: {
      value: _vm.formData.warehouse_code,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "warehouse_code", $$v);
      },
      expression: "formData.warehouse_code"
    }
  }, _vm._l(_vm.rowData.warehouseList || [], function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.warehouse_code
      }
    }, [_vm._v(" " + _vm._s(item.warehouse_name_text) + " ")]);
  }), 1)], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u662F\u5426\u9700\u8981\u5305\u6750"),
      "prop": "need_package",
      "label": _vm.t('是否需要包材')
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('请选择'),
      "disabled": _vm.detailsData.sku_wrapper_type === _vm.$enum.product.ProductSkuWrapperTypeEnum.SALES_WRAPPER
    },
    on: {
      "change": _vm.handleNeedPackage
    },
    model: {
      value: _vm.formData.need_package,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "need_package", $$v);
      },
      expression: "formData.need_package"
    }
  }, _vm._l(_vm.packageisNeedEnum, function (item) {
    return _c('a-select-option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(" " + _vm._s(item.text) + " ")]);
  }), 1)], 1), _vm.formData.need_package === _vm.$enum.common.Enabled.YES ? _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5305\u6750\u5F52\u5C5E"),
      "prop": "sku_wrapper_source",
      "label": _vm.t('包材归属')
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('请选择包材归属')
    },
    on: {
      "change": _vm.handleSkuWrapperSourceChange
    },
    model: {
      value: _vm.formData.sku_wrapper_source,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "sku_wrapper_source", $$v);
      },
      expression: "formData.sku_wrapper_source"
    }
  }, _vm._l(_vm.skuWrapperSourceEnum, function (item) {
    return _c('a-select-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "disabled": item.value === _vm.$enum.product.SkuWrapperSourceEnum.PRIVATE && !_vm.isProductPrivateWrapper
      }
    }, [_vm._v(" " + _vm._s(item.text) + " ")]);
  }), 1)], 1) : _vm._e(), _vm.formData.need_package === _vm.$enum.common.Enabled.YES ? _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5305\u6750\u9009\u62E9\u65B9"),
      "prop": "package_select",
      "label": _vm.t('包材选择方')
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('请选择包材选择方')
    },
    on: {
      "change": _vm.handlePackageSelect
    },
    model: {
      value: _vm.formData.package_select,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "package_select", $$v);
      },
      expression: "formData.package_select"
    }
  }, _vm._l(_vm.packageSelectEnum, function (item) {
    return _c('a-select-option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(" " + _vm._s(item.text) + " ")]);
  }), 1)], 1) : _vm._e(), _vm.formData.package_select === _vm.$enum.product.PackageSelectEnum.SELF ? _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5305\u6750\u8981\u6C42"),
      "prop": "package_req",
      "label": _vm.t('包材要求')
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('请选择包材要求')
    },
    on: {
      "change": _vm.handlePackageReqChange
    },
    model: {
      value: _vm.formData.package_req,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "package_req", $$v);
      },
      expression: "formData.package_req"
    }
  }, _vm._l(_vm.packageReqEnum, function (item) {
    return _c('a-select-option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(" " + _vm._s(item.text) + " ")]);
  }), 1)], 1) : _vm._e(), _vm.formData.package_select === _vm.$enum.product.PackageSelectEnum.SELF ? _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5305\u6750\u7F16\u7801"),
      "prop": "package_code",
      "label": _vm.t('包材编码')
    }
  }, [_c('my-auto-complete', {
    attrs: {
      "allow-clear": ""
    },
    on: {
      "change": _vm.handlePackageCodeChange
    },
    model: {
      value: _vm.formData.package_code,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "package_code", $$v);
      },
      expression: "formData.package_code"
    }
  }, [_c('template', {
    slot: "dataSource"
  }, _vm._l(_vm.wrapperOptionList, function (item) {
    return _c('a-select-option', {
      key: item.package_code,
      attrs: {
        "value": item.package_code
      }
    }, [_vm._v(" " + _vm._s(item.package_code) + "[" + _vm._s(item.package_name) + "]")]);
  }), 1)], 2)], 1) : _vm._e()], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "data-permission": "product_wrapper_add_cancel",
      "id": "product_wrapper_add_cancel",
      "data-sign": "product_wrapper_add_edit_cancel",
      "fbu-analyse-name": $t("\u53D6\u6D88")
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v(_vm._s(_vm.t('取消')))]), _c('a-button', {
    attrs: {
      "data-permission": "product_wrapper_add_save",
      "id": "product_wrapper_add_save",
      "type": "primary",
      "data-sign": "product_wrapper_add_edit_submit",
      "loading": _vm.loading,
      "fbu-analyse-name": $t("\u4FDD\u5B58")
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v(_vm._s(_vm.t('保存')))])], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };